import React from 'react';

const Upload = ({ id, onUpload, multiple, children }) => {
  const handleChange = (e) => {
    const { files } = e.target;
    fileListToArray(files).forEach((f) => {
      onUpload(f);
    });
  };

  const fileListToArray = (list) => {
    const array = [];
    for (let i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  };

  return (
    <div>
      <input
        style={{ display: 'none' }}
        id={id}
        multiple={multiple}
        type='file'
        onChange={handleChange}
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
};

export default Upload;
